import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function ArrowOut({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M8.58331 1.94434H11.6944C12.6766 1.94434 13.4722 2.73989 13.4722 3.72211V11.2777C13.4722 12.2599 12.6766 13.0554 11.6944 13.0554H8.58331"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4722 4.38867L2.36108 7.49978L5.4722 10.6109"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.36108 7.49976H9.02775"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
